import { PropsWithChildren } from "react";

import Breadcrumbs from "@design-system/Breadcrumbs/Breadcrumbs";
import { Header } from "@design-system/Header/Header";

type Props = PropsWithChildren;

export const PortalHeader = ({ children }: Props) => {
  return (
    <Header>
      <Header.Slot>
        <Breadcrumbs />
      </Header.Slot>
      {children && <Header.Slot>{children}</Header.Slot>}
    </Header>
  );
};
